import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Row, Col, Image } from 'react-bootstrap';
import {t} from 'i18next';

class ImageSelection extends Component {

    static propTypes = {
        field: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        field: null,
        onChange: () => {},
    };

    constructor(props){
        super(props);
        this.state = {
            selectModal: false
        };
        this.handleSelectModalOpen = this.handleSelectModalOpen.bind(this);
        this.handleSelectModalClose = this.handleSelectModalClose.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    handleSelectModalOpen() {
        this.setState({
            selectModal: true
        });
    }

    handleSelectModalClose() {
        this.setState({
            selectModal: false
        });
    }

    handleOnChange(choice) {
        this.props.onChange( choice, this.props.field );
        this.handleSelectModalClose();
    }

    render() {
        const { field } = this.props;
        let parts = [];

        if ( field.choices ) {
            parts.push(<div className="jiffy--image-selection__select-image" key="select-image">
                <Button type="button" onClick={this.handleSelectModalOpen}>{t('Select')}</Button>
                {this.state.selectModal && <Modal show onHide={this.handleSelectModalClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t('Please select from existing images')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            {Object.values(field.choices).map( choice => {
                                return <Col xs={12} sm={4} key={choice.ID} >
                                    <Button bsSize="sm" type="button" onClick={() => this.handleOnChange(choice)}>
                                        {choice.sizes.thumbnail
                                            ? <Image src={choice.sizes.thumbnail} alt={choice.url}/>
                                            : <div className="jiffy--image-selection__missing-thumbnail">{t('Missing Thumbnail')}</div>
                                        }</Button>
                                </Col>
                            })}
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleSelectModalClose}>{t('Cancel')}</Button>
                    </Modal.Footer>
                </Modal>}
            </div>)
        }

        if (field.value) {
            // Current value part
            parts.push(<div className="jiffy--image-selection__current-image" key="current-image">
                <input type="hidden" name={field.name} value={field.value.ID} />
                <a href={field.value.url} target="_blank" rel="noopener noreferrer">
                    {field.value.sizes.thumbnail
                        ? <Image src={field.value.sizes.thumbnail} alt={t('Current Image')}/>
                        : <div className="jiffy--image-selection__missing-thumbnail">{t('Missing Thumbnail')}</div>
                    }
                </a>
                <Button bsStyle="danger" bsSize="sm" type="button" onClick={() => this.handleOnChange(null)}>{t('Clear')}</Button>
            </div>)
        }

        return <div className="jiffy--image-selection">
            { parts.map( part => part ) }
        </div>;
    }
};


export { ImageSelection }